import * as React from 'react';

import { TContext } from '../types/context';

// oxlint-disable-next-line typescript/no-explicit-any
export const context = React.createContext<TContext>(null as any);
